import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import styles from './InstagramCard.module.css';


class InstagramCardHeader extends Component {

  render() {
    const { simple } = this.props;


    if (simple)
      return null;

    return (
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={styles.avatar}>
            RN
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title="T&C Says Thank You"
        subheader="April 1, 2020 <- April Fools"
      />
    );
  }
}

class InstagramCard extends Component {
  constructor(props) {
    super(props);

    this.state = {

    }
  }

  render() {
    const { image, simple } = this.props;


    return (
      <Card className={ styles.root }>
        <InstagramCardHeader simple={ simple } />
        <CardMedia
          className={ styles.media }
          image={ image }
          title=""
          width="100%"
        />
        {/*<CardContent>
          <Typography variant="body2" color="textSecondary" component="p">
            Whatever you want. Text on Text on Text. Goes on Forever
          </Typography>
        </CardContent>*/}
        {/*<CardActions disableSpacing>
          <IconButton aria-label="add to favorites">
            <FavoriteIcon />
          </IconButton>
          <IconButton aria-label="share">
            <ShareIcon />
          </IconButton>
          <IconButton
            className={clsx(styles.expand, {
              //[styles.expandOpen]: expanded,
            })}
            //onClick={handleExpandClick}
            //aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </IconButton>
        </CardActions>*/}
        {/*<Collapse timeout="auto" unmountOnExit>
          <CardContent>
            <Typography paragraph>Method:</Typography>
            <Typography paragraph>
              Heat 1/2 cup of the broth in a pot until simmering, add saffron and set aside for 10
              minutes.
            </Typography>
            <Typography paragraph>
              Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet over medium-high
              heat. Add chicken, shrimp and chorizo, and cook, stirring occasionally until lightly
              browned, 6 to 8 minutes. Transfer shrimp to a large plate and set aside, leaving chicken
              and chorizo in the pan. Add pimentón, bay leaves, garlic, tomatoes, onion, salt and
              pepper, and cook, stirring often until thickened and fragrant, about 10 minutes. Add
              saffron broth and remaining 4 1/2 cups chicken broth; bring to a boil.
            </Typography>
            <Typography paragraph>
              Add rice and stir very gently to distribute. Top with artichokes and peppers, and cook
              without stirring, until most of the liquid is absorbed, 15 to 18 minutes. Reduce heat to
              medium-low, add reserved shrimp and mussels, tucking them down into the rice, and cook
              again without stirring, until mussels have opened and rice is just tender, 5 to 7
              minutes more. (Discard any mussels that don’t open.)
            </Typography>
            <Typography>
              Set aside off of the heat to let rest for 10 minutes, and then serve.
            </Typography>
          </CardContent>
        </Collapse>*/}
      </Card>
    );
  }
}

export default InstagramCard;
